export default __webpack_public_path__ + "static/media/ssangyong.b07d04cb.jpg";